import { authenticatedApiRequest } from "./core";
import type { SupportedVendor } from "@/types";

export const vendorsApi = {
  getSupportedVendors: async (): Promise<SupportedVendor[]> => {
    return authenticatedApiRequest<SupportedVendor[]>("/imports/vendors");
  },
};
